import { gql } from '@apollo/client';

export interface JoinCarpoolTripMutation {
  joinCarpoolTrip: {
    id: string;
  };
}

export interface JoinCarpoolTripMutationVariables {
  tripId: string;
}

export const JOIN_CARPOOL_TRIP = gql`
  mutation JoinCarpoolTrip($tripId: ID!) {
    joinCarpoolTrip(tripId: $tripId) {
      id
    }
  }
`;
